import { ErrorHandler, NgModule } from "@angular/core";
import {
  BrowserModule,
  BrowserTransferStateModule,
  HammerModule,
} from "@angular/platform-browser";
import {
  BrowserAnimationsModule
} from "@angular/platform-browser/animations";
import { ExtraOptions } from "@angular/router";

// Components
import { AppComponent } from "./app.component";
import { ErrorPageComponent } from "./pages/error-page/error-page.component";

// Services
import { DefaultComponent } from "./partials/default/default.component";

// Pipes
// import { FindInPipe } from './pipes/find-in.pipe';
import { SnackBarComponent } from "./partials/dialog/builder/snack-bar/snack-bar.component";
// tslint:disable-next-line:max-line-length
import { OpenConnectComponent } from "./pages/open-connect/open-connect.component";
import { HttpAuthorizationInterceptor } from "./@core/interceptors/interceptor.service";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import * as Sentry from "@sentry/browser";

import { AppRoutingModule } from "./app-routing.module";
import { GlobalErrorHandler } from "./@core/services/global-error-hundler.service";
import { environment } from "../environments/environment";
import { TransferHttpCacheModule } from "@nguniversal/common";
import { SharedComponentsPublicAPPModule } from "./pages/shared-components-public-main.module";
// const appInitializerFn = (appConfig: AppConfigService) => {
//   return () => {
//     return appConfig.loadAppConfig();
//   };
// };
let env = "dev";
if (environment.production) {
  env = "production";
}
Sentry.init({
  dsn: "https://75a806081ae5470cb2b109fa5cc5350b@o340237.ingest.sentry.io/5480149",
  environment: env,
});
export const routerOptions: ExtraOptions = {
  useHash: false,
  scrollOffset: [0, 64], // [x, y] - adjust scroll offset
  anchorScrolling: "enabled",
  onSameUrlNavigation: "reload",
  scrollPositionRestoration: "enabled",
  // enableTracing: true
};
@NgModule({
  declarations: [
    AppComponent,
    // HeaderComponent,
    // FooterComponent,
    DefaultComponent,
    // FindInPipe,
    ErrorPageComponent,
    // ControlButtonComponent,
    SnackBarComponent,
    OpenConnectComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "app-root" }),
    AppRoutingModule,
    BrowserAnimationsModule,
    HammerModule,
    SharedComponentsPublicAPPModule,
    TransferHttpCacheModule,
    BrowserTransferStateModule,
    // HomepageModule,
    // BuilderModule
  ],
  entryComponents: [
    // FooterComponent,
    // HeaderComponent,
    // Modals
    // Portals
    DefaultComponent,
    // ControlButtonComponent,
    SnackBarComponent,
  ],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthorizationInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
